import { createSlice } from '@reduxjs/toolkit';

export interface LogoutState {
  isLogout: boolean;
}

const initialState: LogoutState = {
  isLogout: false
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout(state) {
      state.isLogout = true;
    }
  }
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;
